import { NgModule } from '@angular/core';
import { DateDiffPipe } from './date-diff.pipe';


@NgModule({
    imports: [],
    exports: [DateDiffPipe],
    declarations: [DateDiffPipe],
    providers: [],
})
export class DateDiffPipeModule { }
